import {ISchedule, IScheduleName, IScheduleSchool} from '@app-types/websocket/schedule.types';

import {createAction} from 'redux-act';

export const createSchedule = createAction<ISchedule>('Create Schedule');

export const changeScheduleName = createAction<IScheduleName>('Change Schedule name');

export const changeScheduleSchool = createAction<IScheduleSchool>('Change Schedule school');





// WEBPACK FOOTER //
// ./src/services/schedule/schedule.action.ts